import {inject} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CanActivateFn, Router} from '@angular/router';
import {AlertConfig, AlertDialogComponent} from '@evencel/ui';
import {Navigate} from '@ngxs/router-plugin';
import {Actions, ofActionSuccessful, Store} from '@ngxs/store';

import {distinctUntilChanged, map, mergeMap, of} from 'rxjs';
import {AppState, SaveOpenForm, UpdateDirtyFormIndex} from './states';

export const appGuard: CanActivateFn = () => {
    const store = inject(Store);
    const can = store.selectSnapshot(AppState.accessToken) === undefined;
    if (can == true) {
        store.dispatch(new Navigate(['/401']));
    }
    return can ? false : true;
};

/**
 * Guard to prevent unsaved froms
 * @returns
 */
export const formValidationGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);
    const action$ = inject(Actions);
    const matDialog = inject(MatDialog);

    if (!router.url.includes('/activities/')) {
        return true;
    }

    return store.select(AppState.durtyFormIndex).pipe(
        distinctUntilChanged(),
        mergeMap(number => {
            if (number > -1) {
                let config: AlertConfig = {showDoNotSave: true};
                switch (number) {
                    case 3:
                        config = {showDoNotSave: false};
                        break;
                }
                const ref = matDialog.open(AlertDialogComponent, {data: config});
                return onDialogClose(ref, store, action$);
            } else {
                return of(true);
            }
        })
    );
};

export function onDialogClose(ref: MatDialogRef<AlertDialogComponent, unknown>, store: Store, action$: Actions) {
    return ref.afterClosed().pipe(
        mergeMap(dialogResponse => {
            // "Save" action
            if (dialogResponse === true) {
                return store.dispatch(new SaveOpenForm(dialogResponse)).pipe(
                    mergeMap(() => {
                        return action$.pipe(
                            ofActionSuccessful(UpdateDirtyFormIndex),
                            map(a => {
                                return a.index > -1 ? false : true;
                            })
                        );
                    })
                );
            }
            // "Cancel" action
            else if (dialogResponse === undefined) {
                return of(false);
            }
            // "Do not save" action
            else {
                store.dispatch(new UpdateDirtyFormIndex(-1));
                return of(true);
            }
        })
    );
}
